import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 0a1 1 0 1 0 0 2h1v15.132l-1.445-.964a.997.997 0 0 0-1.11 0L13 17.798l-2.445-1.63a.997.997 0 0 0-1.11 0L7 17.798l-2.445-1.63a.997.997 0 0 0-1.11 0L2 17.132V2h1a1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1.555.832L4 18.202l2.445 1.63a.997.997 0 0 0 1.11 0L10 18.202l2.445 1.63a.997.997 0 0 0 1.11 0L16 18.202l2.445 1.63a1.006 1.006 0 0 0 1.027.05A1 1 0 0 0 20 19V1a1 1 0 0 0-1-1h-2zm-6.977 9c-.026-.001-.649-.04-1.316-.707a.999.999 0 1 0-1.414 1.414A4.491 4.491 0 0 0 9 10.8v.2a1 1 0 1 0 2 0v-.185A2.995 2.995 0 0 0 13 8c0-2.281-1.727-2.712-2.758-2.97C9.127 4.751 9 4.646 9 4c0-.552.448-1 .976-1 .026.001.65.04 1.317.707a.999.999 0 1 0 1.414-1.414A4.506 4.506 0 0 0 11 1.2V1a1 1 0 1 0-2 0v.185A2.993 2.993 0 0 0 7 4c0 2.281 1.726 2.712 2.757 2.97C10.872 7.249 11 7.354 11 8c0 .552-.449 1-.977 1"
});

var SvgBillingStatementDollarMajorMonotone = function SvgBillingStatementDollarMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgBillingStatementDollarMajorMonotone as S };
